import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import DefeitoFabricacao from "model/meta/producao/DefeitoFabricacao";
import MetaProducao from "model/meta/producao/MetaProducao";
import MetaProducaoHorario from "model/meta/producao/MetaProducaoHorario";
import MetaProducaoOperacao from "model/meta/producao/MetaProducaoOperacao";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useInterval } from "primereact/hooks";
import { useEffect, useState } from "react";
import MetaProducaoDashboardService from "service/meta/producao/MetaProducaoDashboardService";
import { converterData, converterHorario } from "utils/convert";

const metaProducaoDashboardService = new MetaProducaoDashboardService();
export default function MetaProducaoDefeitoDashboard() {

    const [data, setData] = useState<Date | null>(new Date());
    const [metas, setMetas] = useState<MetaProducao[]>([]);

    const [meta, setMeta] = useState<MetaProducao | null>(null);
    const [metaOperacao, setMetaOperacao] = useState<MetaProducaoOperacao | null>(null);

    const [total, setTotal] = useState<number>(0);

    const [metaComApontamentos, setMetaComApontamentos] = useState<MetaProducao | null>(null);

    const [apontamentosPorDefeito, setApontamentosPorDefeito] = useState<{ defeito: DefeitoFabricacao, quantidade: number }[]>([]);

    useInterval(() => {
        if (metaOperacao) {
            loadMeta(metaOperacao?.id || 0);
        }
    }, 120000);

    useEffect(() => {
        if (data) {
            loadMetas();
        }
    }, [data]);

    useEffect(() => {
        if (metaOperacao) {
            loadMeta(metaOperacao?.id || 0);
        }
    }, [metaOperacao]);

    function loadMetas() {
        metaProducaoDashboardService.buscarMetas(converterData(data)).then((data) => {
            console.log(data);
            setMetas(data);
            if (data.length > 0) {
                setMeta(data[0]);
                setMetaOperacao(data[0].operacoes[data[0].operacoes.length - 1]);
            } else {
                setMeta(null);
                setMetaOperacao(null);
                setMetaComApontamentos(null);
                setTotal(0);
            }
        }).catch(err => {
            console.error(err);
        });
    }

    function loadMeta(idMetaOperacao: number) {
        metaProducaoDashboardService.buscarMeta(idMetaOperacao).then((data) => {
            let apontamentosPorDefeito: { defeito: DefeitoFabricacao, quantidade: number }[] = [];
            let total = 0;
            data?.horarios.forEach(horario => {
                let soma = 0;
                if (horario.apontamentos) {
                    horario.apontamentosDefeito.map(apontamento => {
                        soma += apontamento.quantidade;

                        let index = apontamentosPorDefeito.findIndex(defeito => defeito.defeito.id === apontamento.defeitoFabricacao?.id);
                        if (index > -1) {
                            apontamentosPorDefeito[index].quantidade += apontamento.quantidade;
                        } else {
                            apontamentosPorDefeito.push({ defeito: apontamento.defeitoFabricacao as DefeitoFabricacao, quantidade: apontamento.quantidade });
                        }
                    })
                }
                horario.total = soma;
                total += soma;

                let somaDefeito = 0;
                if (horario.apontamentosDefeito) {
                    horario.apontamentosDefeito.map(apontamento => {
                        somaDefeito += apontamento.quantidade;
                    })
                }
                horario.totalDefeito = somaDefeito;
            });
            setTotal(total);
            setMetaComApontamentos(data);
            console.log(apontamentosPorDefeito);
            setApontamentosPorDefeito(apontamentosPorDefeito);

        }).catch(err => {
            console.error(err);
        });
    }

    return (
        <>
            <div style={{ display: "flex", columnGap: 20 }}>
                <DataTable value={metaComApontamentos?.horarios} emptyMessage="Nenhum registro encontrado">
                    <Column header="Horários" headerStyle={{ color: "#FFF", fontSize: 20, background: "#240E92" }} style={{ width: 160, fontSize: 20 }} body={(rowData: MetaProducaoHorario) => converterHorario(rowData.horaInicio) + " às " + converterHorario(rowData.horaFim)} />
                    <Column header="Total" headerStyle={{ color: "#FFF", background: "#240E92", display: "flex", justifyContent: "right", fontSize: 20 }} style={{ width: 100, textAlign: "right", fontSize: 28 }} body={(rowData: MetaProducaoHorario) => rowData.total} />
                </DataTable>
                <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>

                        <DatePicker
                            sx={{ width: '32%' }}
                            value={dayjs(data)}
                            onChange={value => {
                                setData(value?.toDate() || null);
                            }}
                        />
                        <Dropdown
                            value={meta}
                            placeholder="Selecione uma meta"
                            style={{ width: '32%' }}
                            options={metas}
                            optionLabel="produto.nome"
                            dataKey="id"
                            onChange={(e) => {
                                if (e.value) {
                                    setMetaOperacao(e.value.operacoes[e.value.operacoes.length - 1]);
                                }
                                setMeta(e.value);
                            }}
                        />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", width: "100%", flexGrow: 1 }}>
                        <div style={{ display: "flex", width: "100%", background: "#f4f4f4" }}>
                            <div style={{ width: "100%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 8 }}>
                                <p style={{ fontWeight: 700, fontSize: 28, textAlign: "center", margin: 0 }}>Total de Defeitos</p>
                            </div>
                        </div>
                        <div style={{ display: "flex", width: "100%", background: "#fff", flexGrow: 1 }}>
                            <div style={{ display: "flex", width: "50%", borderColor: "#c8c8c8", borderWidth: 1, borderStyle: 'solid', padding: 8, alignItems: "center", justifyContent: "center", flexGrow: 1 }}>
                                <p style={{ fontWeight: 700, fontSize: 144, textAlign: "center", margin: 0 }}>{total}</p>
                            </div>
                        </div>

                    </div>
                </div>
                <DataTable value={apontamentosPorDefeito} emptyMessage="Nenhum registro encontrado">
                    <Column header="Defeito" field="defeito.descricao" headerStyle={{ color: "#FFF", fontSize: 20, background: "#240E92" }} style={{ width: 250, fontSize: 20 }} />
                    <Column header="Total" field="quantidade" headerStyle={{ color: "#FFF", background: "#240E92", display: "flex", justifyContent: "right", fontSize: 20 }} style={{ width: 100, textAlign: "right", fontSize: 28 }} />
                </DataTable>
            </div>
        </>
    )
}